import PageNotFound from 'pages/errors/PageNotFound';
import Forbidden from 'pages/errors/Forbidden';
import ServerError from 'pages/errors/ServerError';
import { useTranslation } from 'react-i18next';
const PageRequestError = (props) => {
	const error = props.error;
	const { t } = useTranslation();

	const UNABLE_TO_PROCESS_REQUEST=t("UNABLE_TO_PROCESS_REQUEST")
	const { status = 500, data = UNABLE_TO_PROCESS_REQUEST } = error.response;
	if(status === 404){
		return <PageNotFound message={data} />
	}
	else if(status === 403){
		return <Forbidden message={data} />
	}
	return (
		<ServerError message={data} />
	)
}
export { PageRequestError }